<script setup></script>

<template>
  <footer class="footer">
    <div class="footer__content">
      <h2 class="blind">BITUP</h2>
      <small>BitUP 플랫폼에 대한 접근은 18세 이하의 개인에게 제한됩니다.</small>
      <small>Copyright © 2025. All rights reserved.</small>
    </div>
  </footer>
</template>

<style scoped></style>
